import React, { useContext } from "react";
import Form from "../../components/Form/Form";
import Footer1 from "../../components/Footer1/Footer";
import AboutusImage from "../../assets/images/borku-full-logo.png";
import { LoginHeader } from "../../components/Header";
import Header from "../../components/Header/Header";
import UserContext from "../../context/User";

const AboutUs = () => {
  const { isLoggedIn } = useContext(UserContext);

  return (
    <>
      {isLoggedIn ? <Header /> : <LoginHeader showIcon />}
      <div>
        <Form
          picture={AboutusImage}
          // Full wordmark (as on the admin login) on a white tile
          pictureStyle={{
            background: "#fff",
            padding: "15% 10%",
            boxSizing: "border-box",
            objectFit: "contain",
          }}
          heading="About Us."
          tagline="Borku is your trusted marketplace for food, groceries, pastries, fashion and beauty products, all
in one place.
We connect customers with trusted businesses across the UK, making it easy to discover what
you love and have it delivered straight to your doorstep."
        >
        </Form>
        <Footer1 />
      </div>
    </>
  );
};

export default AboutUs;
